"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.OutsideSSR = exports.InsideSSR = exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _jsxFileName = "/Users/anari/Developer/gatsby-plugin-check-ssr/src/index.js";

const CheckSSR = _react.default.createContext(false);

var _default = CheckSSR;
exports.default = _default;

const InsideSSR = ({
  children
}) => _react.default.createElement(CheckSSR.Consumer, {
  __source: {
    fileName: _jsxFileName,
    lineNumber: 7
  },
  __self: void 0
}, build => build && children);

exports.InsideSSR = InsideSSR;

const OutsideSSR = ({
  children
}) => _react.default.createElement(CheckSSR.Consumer, {
  __source: {
    fileName: _jsxFileName,
    lineNumber: 8
  },
  __self: void 0
}, build => !build && children);

exports.OutsideSSR = OutsideSSR;